module.exports = __webpack_public_path__ + "img/img3.a2be963.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/img3.png
// module id = 396
// module chunks = 0